import { parse, toSeconds } from "iso8601-duration";

import { getJson, put } from "../helpers/request";

const HISTORY_URL = `${__AREENA_API}/v2/raw/profile/history`;
const BASE_PARAMETERS = {
  language: "fi",
  v: 8
};

const urlWithBaseParamsAndKeys = `${HISTORY_URL}?${__API_KEYS}`;

const withHistoryOptions = (programId: string) => ({
  parameters: {
    ...BASE_PARAMETERS,
    ids: programId
  },
  url: HISTORY_URL,
  withCredentials: true
});

interface HistoryData {
  [programId: string]: {
    elapsed: string;
    finished: boolean;
    date: number;
  } | null;
}

export const getAreenaWatchedHistoryData = async (
  programId: string
): Promise<{
  watchedDuration?: number;
}> => {
  const getHistory = async (): Promise<HistoryData> => {
    try {
      return await getJson<HistoryData>(withHistoryOptions(programId));
    } catch (e) {
      return {};
    }
  };

  const history = await getHistory();
  const elapsed = history[programId]?.elapsed ?? "PT0S";
  return {
    watchedDuration: toSeconds(parse(elapsed))
  };
};

interface SaveHistoryBody {
  programId: string;
  time: number;
}

const withHistorySavingOptions = ({ programId, time }: SaveHistoryBody) => ({
  body: { time },
  parameters: {
    ...BASE_PARAMETERS
  },
  url: `${HISTORY_URL}/${encodeURIComponent(programId)}`,
  withCredentials: true
});

export type Save = (props: SaveHistoryBody) => void;

export const sendBeacon: Save = ({ programId, time }) => {
  if (time !== 0) {
    const data = new FormData();
    data.append("programId", programId);
    data.append("time", time.toString());
    navigator.sendBeacon(urlWithBaseParamsAndKeys, data);
  }
};

export const save: Save = ({ programId, time }) => {
  if (time !== 0) {
    put(withHistorySavingOptions({ programId, time }));
  }
};
